import type { ComposerTranslation } from 'vue-i18n'

export type PolicyBindScopeFormSlice = {
  bind_mode?: number
  group_ids?: (number | string)[]
  device_ids?: string[]
}

/**
 * CmForm / getFormItemRules：rules 项需带 `required: false`，否则会叠加大表单的 required。
 * 分组模式至少选一个分组；终端模式至少选一台终端。
 * 应用范围表单项的 `formItemOpt.required` 须为 false，否则 Element 会对 `group_ids` 做必填，终端模式下会误报「group_ids is required」。
 */
export function policyBindScopeFormRules(
  getForm: () => PolicyBindScopeFormSlice,
  t: ComposerTranslation,
) {
  return [
    {
      required: false as const,
      custom: {
        validator: (_rule: unknown, _value: unknown, callback: (e?: Error) => void) => {
          const f = getForm()
          const bm = Number(f.bind_mode ?? 0)
          // 分组模式：校验 group_ids。终端模式（bind_mode === 1）：只按 device_ids.length 判断，不看 group_ids
          if (bm === 0) {
            if (!(f.group_ids?.length)) {
              callback(new Error(String(t('policyBindScope.needGroups'))))
              return
            }
          } else {
            // 终端模式（1）等非分组：必填依据为 device_ids 数量，与 group_ids 无关
            const terminalCount = f.device_ids?.length ?? 0
            if (terminalCount < 1) {
              callback(new Error(String(t('policyBindScope.needTerminals'))))
              return
            }
          }
          callback()
        },
        trigger: ['change', 'blur'],
      },
    },
  ]
}
